

/**
FORMAT : import { name } from '<imports>';
Name should match that exported in the package exported from!
Check readme.MD for instructions in node_modules under the respective names
**/

//Declare @angular Modules
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControl,FormGroup } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

//routing module
import { RoutingModule } from './routing.module';

//Declare other Modules
// import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { HttpModule } from '@angular/http';

import { DndModule } from 'ng2-dnd';
import { DynamicHTMLModule,DynamicComponentModule } from 'ng-dynamic';
import { ToastyModule } from 'ng2-toasty';
import { MomentModule } from 'angular2-moment';
import { HttpClientModule } from '@angular/common/http';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxPaginationModule } from 'ngx-pagination';
import { SelectModule } from 'ng-select';
import { PopupModule} from 'ng2-opd-popup';
import { ExcelService } from './excel.service';
import { CsvService} from 'angular2-json2csv';
import { AppModule as FilterModule } from 'ng-filter';
// import { ChartsModule } from 'ng2-charts';
// import { NgxGaugeModule } from 'ngx-gauge';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { FullCalendarModule } from 'ng-fullcalendar';
import { AutocompleteModule } from 'ng2-input-autocomplete';
import { NgxMaskModule } from 'ngx-mask'
import { AgmCoreModule } from '@agm/core';
// import { DoughnutChartComponent, PieChartComponent, BarChartComponent } from 'angular-d3-charts';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { FileUploadModule } from 'ng2-file-upload';

import { DxPieChartModule } from 'devextreme-angular';
import { DxChartModule } from 'devextreme-angular';
// Declare Components :
import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ThreeTimeOrMorePostponementReportComponent } from './three-time-or-more-postponement-report/three-time-or-more-postponement-report.component';
import { ServiceDueReportComponent } from './service-due-report/service-due-report.component';
import { StatusReportOneMonthBeforeComponent } from './status-report-one-month-before/status-report-one-month-before.component';
import { InactiveCustomerReportComponent } from './inactive-customer-report/inactive-customer-report.component';
import { CustomerContractReportComponent } from './customer-active-inactive-report/customer-active-inactive-report.component';
import { CustomerMachineSummaryReportComponent } from './customer-machine-summary-report/customer-machine-summary-report.component';
import { CustomerNoContractReportComponent } from './customer-no-contract-report/customer-no-contract-report.component';
import { CheckListMasterComponent } from './check-list-master/check-list-master.component';
import { MyformComponent } from './myform/myform.component';
import { CustomerMasterComponent } from './customer-master/customer-master.component';
import { CheckListDetailsComponent } from './check-list-details/check-list-details.component';
import { PreventiveMaintenanceComponent } from './preventive-maintenance/preventive-maintenance.component';
import { ServiceContractComponent } from './service-contract/service-contract.component';
import { PostPonedFormComponent } from './postPoned-form/postPoned-form.component';
import { CalenderComponent } from './calender/calender.component';
import { MakeComponent } from './make/make.component';
import { ModelComponent } from './model/model.component';
import { LabourCostComponent } from './labour-cost/labour-cost.component';
import { ServiceTypeComponent } from './service-type/service-type.component';
import { HistoryComponent } from './history/history.component';
import { BranchComponent } from './branch/branch.component';
import { DescriptionComponent } from './description/description.component';
import { EmiratesComponent } from './emirates/emirates.component';
import { AlertComponent } from './alert/alert.component';
import { AlertHistoryComponent } from './alert-history/alert-history.component';
import { PartdetailsComponent } from './partdetails/partdetails.component';
import { TravelcostComponent} from './travelcost/travelcost.component';
import { SublocalityComponent} from './sublocality/sublocality.component';
import { LoopComponent } from './loop/loop.component';
//custom Service
import { OrderByPipe} from "./service-due-report/orderby.pipe";
import { AuthPublicService } from './auth.service';
// import {OrginalEnddatebasedReportComponent} from './orginal-enddatebased-report/orginal-enddatebased-report.component'
import {ServiceEndDateComponent} from './service-end-date/service-end-date.component';
import {PmaCategoryComponent} from './pma-category/pma-category.component';
import { InvoiceReportComponent } from './invoice-report/invoice-report.component';
import { VirComponent } from './vir/vir.component';
import { AddMailComponent } from './add-mail/add-mail.component';


@NgModule({
  declarations: [  // Components in here
    AppComponent,
    NotFoundComponent,  
    DashboardComponent,
    ThreeTimeOrMorePostponementReportComponent,
    ServiceDueReportComponent,
    StatusReportOneMonthBeforeComponent,
    InactiveCustomerReportComponent,
    CustomerContractReportComponent,
    CustomerMachineSummaryReportComponent,
    CustomerNoContractReportComponent,
    CheckListMasterComponent,
    CheckListDetailsComponent,
    MyformComponent,
    CustomerMasterComponent,
    PreventiveMaintenanceComponent,
    ServiceContractComponent,
    PostPonedFormComponent,
    OrderByPipe,
    CalenderComponent,
    MakeComponent,
    ModelComponent,
    LabourCostComponent,
    ServiceTypeComponent,
    HistoryComponent,
    BranchComponent,
    DescriptionComponent,
    EmiratesComponent,
    AlertComponent,
    TravelcostComponent,
    SublocalityComponent,
    ServiceEndDateComponent,
    LoopComponent,
    PmaCategoryComponent,
    VirComponent,
    // DoughnutChartComponent,
    // PieChartComponent,
    // BarChartComponent,
    AlertHistoryComponent,
    PartdetailsComponent,
    InvoiceReportComponent,
    AddMailComponent
    // OrginalEnddatebasedReportComponent
  ],
  imports: [     // Modules in here
    PopupModule.forRoot(),
    RoutingModule,
    HttpModule,
    GooglePlaceModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    // MultiselectDropdownModule,
    MomentModule,
    FilterModule,
    Ng2SearchPipeModule,
    DndModule.forRoot(),
    PopupModule.forRoot(),
    NgxPaginationModule,
    ToastyModule.forRoot(),
    AutocompleteModule.forRoot(),
    FullCalendarModule,
    // NgxGaugeModule,
    RoundProgressModule,
    BootstrapModalModule,  
    FileUploadModule,
    NgxMaskModule,
    DxPieChartModule,
    DxChartModule,
    AgmCoreModule.forRoot({
      apiKey:'AIzaSyCTK07AppZAiE0nxsrCtgjK37aGiwv-dqc'
    }),
    SelectModule,
    // ChartsModule,
    DynamicHTMLModule.forRoot({
      components: [
      ]
    }),

  ],
  providers: [  // Services in here
    AuthPublicService,
    ExcelService,
    CsvService 
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents:[
      AlertComponent,
      AlertHistoryComponent
  ],  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./client/app/app.module.ts